import React, { useState, useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import NavMenu from 'components/NavMenu';
import KeyUserAdvanceForm from 'app/components/KeyUserAdvanceForm';
import KeyUserAdvanceDetailForm from 'app/components/KeyUserAdvanceDetailForm';
import CommunicationProgramKeyUserManagmentForm from 'app/components/CommunicationProgramKeyUserManagmentForm';
import CommunicationProgramSummaryContainer from 'app/containers/CommunicationProgramKeyUserSummaryContainer';

import Chart from 'react-google-charts';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import { Table, Drawer, Button, Spin, Icon, Col, Row, Badge } from 'antd'
import { clearCommunicationProgramDetails, clearCommunicationProgramSummary, clearGraphics } from 'app/actions/CommunicationProgramKeyUserActions';
import { clearComplianceAdvance } from 'app/actions/CommunicationActions';
import { useStyles, styles } from './KeyUserAdvanceScreenStyles';
import { useDispatch, useSelector } from 'react-redux';
import { Pie3D } from 'react-pie3d'

export default function ComplianceAdvanceScreen(props) {
	const classes = useStyles();
	const dispatch = useDispatch();

	const [filter, setFilter] = useState([]);
	const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
	const [sorter, setSorter] = useState({});
	const [formData, setFormData] = useState({});
	const [categoryData, setCategoryData] = useState({});
	const [isVisible, setVisible] = useState();
	const [isVisibleChildren, setVisibleChildren] = useState();
	const [rowData, setRowData] = useState();
	const [front, setFront] = useState([]);
	const [training, setTraining] = useState([]);
	const [cp, setCP] = useState([]);
	const finishedColor = '#4D9AD7';
	const pendingColor = '#EA712E'
	const finishedColorStrong = '#3567CC' //'#056ccc';
	const pendingColorStrong = '#DD392A' //'#f32404'

	const PieConfig = {
		angle: 70,
		tooltipShowName: true,
		tooltipShowPercentage: true,
		tooltipShowValue: true,
		showTooltips: true,
		ir: 0,
		size: 1,
		moveDistance: 0,
		height: 15
	}


	let [title, setTitle] = useState('% cumplimiento (Avance/Pendiente) - Resúmen global');

	const {
		idSubdirection
	} = useSelector(state => state.Auth.employeeById)

	useEffect(() => {
		return () => {
			dispatch(clearCommunicationProgramSummary());
			dispatch(clearGraphics());
		}
	}, []);

	const onBack = () => {
		dispatch(clearCommunicationProgramDetails())
		setVisible(false)
	}
	const onBackChildren = () => {
		dispatch(clearComplianceAdvance())
		setVisibleChildren(false)
	}

	const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

	return (
		<div className={classes.root}>
			<NavMenu SelectedIndex={props.history.location.pathname} isManag={true} header='Seguimiento de Avance de cumplimiento Key User' isCommunicationStatus={false} />
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.appBarSpacer} />
				<div elevation={0} style={styles.titleBox}>
					<Breadcrumbs aria-label='Breadcrumb'>
						<Link color='inherit' disabled>
							Gestión
						</Link>
						<TextEvents
							text={'Estadísticas de seguimiento de avance de cumplimiento Key User'}
							color='cotemar'
							size='subtitle'
							weight='bold'
						/>
					</Breadcrumbs>
				</div>
				<Paper className={classes.rootPaper}>
					<KeyUserAdvanceForm filter={filter} setFilter={setFilter} pagination={pagination} sorter={sorter}
						formData={formData} setFormData={setFormData} styles={styles} classes={classes}
						front={front} setFront={setFront} training={training} setTraining={setTraining}
						cp={cp} setCP={setCP} />
					<Divider light />
					<div style={styles.baseVerticalMargin}>
						<CommunicationProgramSummaryContainer
							classes={classes}
							sorter={sorter}
							setSorter={setSorter}
							pagination={pagination}
							setPagination={setPagination}
							formData={formData}
							setVisible={setVisible}
							setRowData={setRowData}
							subdirectionId={idSubdirection}
							front={front} setFront={setFront} training={training} setTraining={setTraining}
							cp={cp} setCP={setCP}
						>
							{(params) => {
								if (params.graphics.DataGraphics !== undefined) {
									
									if (params.graphics.DataGraphics.GeneralPercentage === 0) {
										setTitle('No existen datos que mostrar')
									}
									else {
										setTitle('% cumplimiento (Avance/Pendiente) - Resúmen global')
									}

								}
								return params.graphics.DataGraphics !== undefined ?
									<div>
										<div className={classes.rootCharts}>
											<div className={classes.textPercentage}>
												<TextEvents
													text={'Cumplimiento General: '}
													color='dark'
													size='subtitle'
													weight='bold'
													align='center'
												/>
												<TextEvents
													text={` ${params.graphics.DataGraphics.GeneralPercentage}%`}
													color='green'
													size='subtitle'
													weight='bold'
													align='center'
												/>
											</div>
											<div className={classes.divCharts}>
												{/* SE ELIMINA GRAFICA LINEAL POR COMENTARIO DE ING RIVERA EN REUNION 2021-11-24 */}
												{/*Object.keys(formData).length > 0
													? <div>
														{params.eachChild.length > 1 && formData.SubdirectionId ?
															<Chart
																width={'500px'}
																height={'300px'}
																chartType='BarChart'
																loader={<Icon type="loading" />}
																data={params.eachChild}
																options={{
																	title: '% cumplimiento (Avance/Pendiente) por contrato',
																	chartArea: { width: '50%' },
																	isStacked: true,
																	vAxis: {
																		title: 'Contrato',
																	},
																}}
																// For tests
																rootProps={{ 'data-testid': '3' }}
															/> : <div />}
													</div>
													:
													<div />
												*/}
												{/* GRAFICA ONLINE CON CHARTS GOOGLE (DESCOMENTAR PARA USAR) */}
												{/* <Chart
													width={'600px'}
													height={'300px'}
													chartType='PieChart'
													loader={<div><Icon type="loading" />cargando...</div>}
													data={params.chartPieArray}
													options={{
														title: title,
														// Just add this option
														is3D: true,
														sliceVisibilityThreshold: 0.0000001,
														animation: {
															startup: true,
															easing: 'linear',
															duration: 1500,
														},
													}}
													rootProps={{ 'data-testid': '2' }}
												/> */}
												<h3>{title}</h3>
											</div>
											{/* Nuva grafica 'offline', descomentar para usar */}
											<Row align='middle' justify='space-around'>
												<Col span={7}>
												</Col>
												<Col span={6}>
													<Pie3D config={PieConfig} data={[
														{ value: params.chartPieArray[2][1], label: params.chartPieArray[2][2], color: pendingColorStrong },
														{ value: params.chartPieArray[1][1], label: params.chartPieArray[1][2], color: finishedColorStrong },
													]} />
												</Col>
												<Col span={6}>
													<Badge color={pendingColorStrong} text={`Pendiente (${(params.chartPieArray[2][1] * 100 / (params.chartPieArray[1][1] + params.chartPieArray[2][1])).toFixed(2)}%)`} /> <br />
													<Badge color={finishedColorStrong} text={`Finalizado (${(params.chartPieArray[1][1] * 100 / (params.chartPieArray[1][1] + params.chartPieArray[2][1])).toFixed(2)}%)`} />
												</Col>
												<Col span={5}>
												</Col>
											</Row>
										</div>
										<Divider light />
										<Table
											loading={params.isLoading}
											rowKey={item => String(item.idCommunicationProgram)}
											columns={params.cols}
											dataSource={params.communicationProgramSummary}
											onChange={params.handleTableChange}
											pagination={pagination}
											scroll={{ x: 1300 }}
											// scroll={{ x: 'min-content', y: (height - 395) }}
											size={"small"}
										/>
									</div> : <div className={classes.spin}><Spin /> </div>
							}}
						</CommunicationProgramSummaryContainer>
					</div>
				</Paper>
			</div>
			<Drawer
				title={<div className={classes.headerDrawer}><Button onClick={onBack} type='link' icon='left'>Regresar </Button><TextEvents
					text={'Detalle de seguimiento de avance de cumplimiento'}
					color='dark'
					size='label'
					weight='bold'
				/></div>}
				width={'100%'}
				closable={false}
				onClose={() => setVisible(false)}
				visible={isVisible}
				destroyOnClose={true}
			>
				<KeyUserAdvanceDetailForm
					classes={classes}
					filter={filter}
					rowData={rowData}
					pagination={pagination}
					setFilter={setFilter}
					setVisibleChildren={setVisibleChildren}
					sorter={sorter}
					styles={styles}
					setCategoryData={setCategoryData}
					subdirectionId={idSubdirection}
				/>
				<Drawer
					title={<div className={classes.headerDrawer}><Button onClick={onBackChildren} type='link' icon='left'>Regresar </Button><TextEvents
						text={'Gestión de programas de comunicación (Procedimiento-Colaboradores)'}
						color='dark'
						size='label'
						weight='bold'
					/></div>}
					width={'100%'}
					closable={false}
					onClose={() => setVisibleChildren(false)}
					visible={isVisibleChildren}
					destroyOnClose={true}
				>
					<CommunicationProgramKeyUserManagmentForm
						categoryData={categoryData}
						pagination={pagination}
						rowData={rowData}
						sorter={sorter}
						classes={classes}
						styles={styles}
						subdirectionId={idSubdirection}
					/>
				</Drawer>
			</Drawer>
		</div>
	)
}
